import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import { NugetType } from '@models';
import {
    GRID_SERVICE,
    STATE_HANDLER,
    urlStateHandler,
} from '@pages/generics/grid';
import { LibraryService } from '@services/library.service';

import { NugetGridComponent } from './grids';

@Component({
    templateUrl: './grids/nuget/nuget.grid.html',
    providers: [{
        provide: GRID_SERVICE,
        useClass: LibraryService,
    },
    {
        provide: STATE_HANDLER,
        useValue: urlStateHandler,
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibrariesPageComponent
    extends NugetGridComponent
    implements OnInit {
    public type = NugetType.Libraries;

    ngOnInit() {
        this.createPermission = this._appState.user.loggedInAsHost ?
            '' :
            'Libraries.Create';
    }
}
